var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 44,
    viewBox: "0 0 84 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_613_7265)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.888672 22C0.888672 9.84974 10.7384 0 22.8887 0H61.9998C74.15 0 83.9998 9.84974 83.9998 22C83.9998 34.1503 74.15 44 61.9998 44H22.8887C10.7384 44 0.888672 34.1503 0.888672 22Z",
    fill: "url(#paint0_linear_613_7265)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.1851,
    y: 13.0371,
    width: 28.5185,
    height: 3.25926,
    rx: 1.62963,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.1851,
    y: 20.3706,
    width: 28.5185,
    height: 3.25926,
    rx: 1.62963,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.1851,
    y: 27.7036,
    width: 28.5185,
    height: 3.25926,
    rx: 1.62963,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_613_7265",
    x: -8.98223,
    y: -9.8709,
    width: 102.853,
    height: 63.7418,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4.93545
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_613_7265"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_613_7265",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_613_7265",
    x1: 0.888672,
    y1: 22,
    x2: 83.9998,
    y2: 22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B7AC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE96FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon);
export default __webpack_public_path__ + "static/media/menu-icon.2586a1b59f419e347508544bef44a24a.svg";
export { ForwardRef as ReactComponent };